// Block image src to attacker hosts in LLM-rendered content; else it exfiltrates via the load request (ENG-3882)
const ALLOWED_HOST_SUFFIXES = [".orbitshift.ai"]
const ALLOWED_HOSTS = [
  "dmi3q4vtj7try.cloudfront.net",
  "d1j4n95cfpzifc.cloudfront.net"
]

export function isAllowedImageSrc(src: unknown): src is string {
  if (typeof src !== "string" || src.length === 0) return false
  const value = src.trim()
  const lower = value.toLowerCase()
  if (lower.startsWith("data:image/") || lower.startsWith("blob:")) return true
  let url: URL
  try {
    url = new URL(value, "https://app.orbitshift.ai")
  } catch {
    return false
  }
  if (url.protocol !== "https:" && url.protocol !== "http:") return false
  const host = url.hostname.toLowerCase()
  if (ALLOWED_HOSTS.includes(host)) return true
  return ALLOWED_HOST_SUFFIXES.some((suffix) => host.endsWith(suffix))
}

export function safeImageSrc(src: unknown): string | undefined {
  return isAllowedImageSrc(src) ? src : undefined
}
